<app-card [header]="true" cardClasses="mt-10">

  <ng-container cardHeader>
    <app-skeleton-text [height]="25" [width]="230" *ngIf="!baseDatasource.isFinishLoadingSubject.value; else titleTpl">
    </app-skeleton-text>
    <ng-template #titleTpl>
      <h1>List Variant {{brandName}} ({{ baseDatasource.totalItem$ | async }} Variant)</h1>
    </ng-template>
  </ng-container>

  <ng-container cardBody>

    <div class="table-responsive">
      <table
        (matSortChange)="sortTable($event)"
        [dataSource]="baseDatasource"
        class="table w-100 gy-5 table-row-bordered align-middle"
        mat-table
        matSort
      >
        <ng-container *ngFor="let tableColumn of tableColumns" [matColumnDef]="tableColumn.key">
          <ng-container *ngIf="tableColumn.isSortable; else notSortTable">
            <th
              *matHeaderCellDef
              [arrowPosition]="'after'"
              [class.min-w-200px]="tableColumn.key !== 'actions' && tableColumn.key !== 'id'"
              [mat-sort-header]="tableColumn.key"
              class="min-w-125px px-3"
              mat-header-cell
            >
              <div *ngIf="baseDatasource.isFinishLoadingSubject.value">
                {{tableColumn.title}}
              </div>
              <div *ngIf="!baseDatasource.isFinishLoadingSubject.value">
                <app-table-content [width]="70"></app-table-content>
              </div>
            </th>
          </ng-container>
          <ng-template #notSortTable>
            <th
              *matHeaderCellDef
              [class.min-w-200px]="tableColumn.key !== 'actions' && tableColumn.key !== 'id'"
              [ngClass]="{
                'min-w-70px text-center': tableColumn.key === 'actions',
                'w-250px': tableColumn.key === 'alamat'
              }"
              class="min-w-125px px-3"
              mat-header-cell
            >
              <app-table-content [width]="200" [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject">
                {{tableColumn.title}}
              </app-table-content>
            </th>
          </ng-template>
          <td *matCellDef="let element" class="px-3" mat-cell>
            <ng-container [ngSwitch]="tableColumn.key">
              <div *ngSwitchCase="'action'">
                <button [ngClass]="{
                'is-download' : element['is_download']
                }"
                        class="btn btn-table-actions-download"
                >
                <span
                  (click)="handleAction()"
                  [inlineSVG]="STRING_CONSTANTS.ICON.IC_ACTIONS_TABLE"
                ></span>
                </button>
              </div>

              <div *ngSwitchCase="'price_unit'">
                <app-table-content [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject">
                  <div *ngIf="element['detail_variant']">
                    {{toRupiah(element['detail_variant'][tableColumn.key])}}
                  </div>
                </app-table-content>
              </div>

              <div *ngSwitchCase="'price_unit_with_ppn'">
                <app-table-content [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject">
                  <div *ngIf="element['detail_variant']">
                    {{toRupiah( element['detail_variant'][tableColumn.key] )}}
                  </div>
                </app-table-content>
              </div>

              <div *ngSwitchCase="'price_per_box'">
                <app-table-content [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject">
                  <div *ngIf="element['detail_variant']">
                    {{toRupiah(element['detail_variant'][tableColumn.key])}}
                  </div>
                </app-table-content>
              </div>

              <div *ngSwitchCase="'price_per_box_with_ppn'">
                <app-table-content [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject">
                  <div *ngIf="element['detail_variant']">
                    {{toRupiah( element['detail_variant'][tableColumn.key] )}}
                  </div>
                </app-table-content>
              </div>

              <div *ngSwitchDefault>
                <app-table-content [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject">
                  <span>{{ element[tableColumn.key] ?? '-'}} </span>
                </app-table-content>
              </div>
            </ng-container>
          </td>
        </ng-container>
        <tr *matHeaderRowDef="displayedColumns" class="fw-bold text-start text-uppercase" mat-header-row></tr>
        <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
      </table>
    </div>
    <div class="d-flex justify-content-between py-4  hidden-showing-rows">
      <app-mai-material-bottom-table
        (changePage)="changePageEvent($event)"
        [baseDataTableComponent]="baseDatasource"
        [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject"
        class="w-100"
      ></app-mai-material-bottom-table>
    </div>
  </ng-container>
</app-card>
